import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { createUserWithEmailAndPassword, updateProfile } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { auth, db } from '../firebase/config';
import { Cloud, Sun, Wind, User } from 'lucide-react';
import toast from 'react-hot-toast';
import './Login.css';

const Register = () => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Create user account
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // Update profile with username
      await updateProfile(user, {
        displayName: username
      });

      // Create user document in Firestore
      await setDoc(doc(db, 'users', user.uid), {
        username: username,
        email: email,
        createdAt: new Date(),
        friends: [],
        encryptionKey: null
      });

      toast.success('Account created successfully!');
      navigate('/dashboard');
    } catch (error) {
      console.error('Registration error:', error);
      if (error.code === 'auth/configuration-not-found') {
        toast.error('Email/Password sign-in is not enabled for this Firebase project. Enable it in Firebase Console → Authentication → Sign-in method, then try again.');
      } else if (error.code === 'auth/email-already-in-use') {
        toast.error('Email already in use. Please try a different email.');
      } else if (error.code === 'auth/network-request-failed') {
        toast.error('Network error. Check your internet connection and try again.');
      } else {
        toast.error(error.message || 'Registration failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="weather-header">
        <div className="weather-icons">
          <Sun className="weather-icon sun" />
          <Cloud className="weather-icon cloud" />
          <Wind className="weather-icon wind" />
        </div>
        <h1>WeatherCast Pro</h1>
        <p>Your trusted source for weather information</p>
      </div>

      <div className="login-form-container">
        <div className="login-form">
          <h2>Create Your Weather Account</h2>
          <p>Join thousands of users getting accurate weather forecasts</p>
          
          <form onSubmit={handleRegister}>
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <div className="input-with-icon">
                <User className="input-icon" />
                <input
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Choose a username"
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Create a password"
                required
                minLength="6"
              />
            </div>

            <button 
              type="submit" 
              className="login-btn"
              disabled={loading}
            >
              {loading ? 'Creating Account...' : 'Create Account'}
            </button>
          </form>

          <div className="form-footer">
            <p>Already have an account? 
              <Link to="/login" className="link"> Sign in here</Link>
            </p>
          </div>
        </div>
      </div>

      <div className="weather-footer">
        <p>© 2024 WeatherCast Pro. Providing accurate weather forecasts worldwide.</p>
      </div>
    </div>
  );
};

export default Register;
